module.exports = __webpack_public_path__ + "img/logo-dark.c0b42c16.svg";